<template>
	<div class="edit-module">
		<NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
				<v-row no-gutters>
					<v-col cols="12" md="4">
						<v-text-field v-model="plan.name_pt" :label="$gettext('Name') + ' PT'" outlined class="px-2"></v-text-field>
					</v-col>
					<v-col cols="12" md="4">
						<v-text-field v-model="plan.name_en" :label="$gettext('Name') + ' EN'" outlined class="px-2"></v-text-field>
					</v-col>
					<v-col cols="12" md="4">
						<v-text-field v-model="plan.name_es" :label="$gettext('Name') + ' ES'" outlined class="px-2"></v-text-field>
					</v-col>
				</v-row>
				<v-row no-gutters class="mb-7">
					<v-col cols="12" md="2">
						<v-text-field
							v-model="plan.num_professionals"
							:label="$gettext('Max. Professionals')"
							outlined
							class="px-2"
						></v-text-field>
					</v-col>
					<v-col cols="12" md="2">
						<v-text-field
							v-model="plan.num_secretaries"
							:label="$gettext('Max. Secretaries')"
							outlined
							class="px-2"
						></v-text-field>
					</v-col>
					<v-col cols="12" md="2">
						<v-text-field
							v-model="plan.num_patients"
							:label="$gettext('Max. Patients')"
							outlined
							class="px-2"
						></v-text-field>
					</v-col>
					<v-col cols="12" md="2">
						<v-text-field
							v-model="plan.disk_space"
							:label="$gettext('Disk space')"
							outlined
							class="px-2"
						></v-text-field>
					</v-col>
					<v-col cols="12" md="2">
						<v-text-field
							v-model="plan.discount_percentage"
							:label="$gettext('Discount Percentage')"
							outlined
							class="px-2"
						></v-text-field>
					</v-col>
					<v-col cols="12" md="2">
						<v-text-field
							v-if="plan.code == 'free'"
							v-model="plan.free_days"
							:label="$gettext('Free Days')"
							outlined
							class="px-2"
						></v-text-field>
					</v-col>
					<v-col v-for="(pricingPlan, i) in plan.pricing_plans" cols="12" md="12" :key="i">
						<v-row no-gutters align="center">
							<v-col cols="12" md="2">
								{{pricingPlan.months}}
								<translate v-if="pricingPlan.months == 1">Month</translate>
								<translate v-else>Months</translate>
							</v-col>
							<v-col cols="12" md="4">
								<v-text-field
									v-model="pricingPlan.price"
									:label="$gettext('Price')"
									outlined
									class="px-2"
									hide-details
									type="number"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="4">
								<v-text-field
									v-model="pricingPlan.discount"
									:label="$gettext('Discount')"
									outlined
									class="px-2"
									hide-details
									type="number"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="2">
								<v-checkbox v-model="pricingPlan.active" color="primary" :label="$gettext('Active')"></v-checkbox>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12" sm="12" class="mt-5">
						<v-alert v-model="error" color="red lighten-4" icon="error" class="text-caption">
							<translate>Error</translate>
						</v-alert>
						<v-btn color="primary" class="float-right ml-2" @click="savePlan">
							<translate>Save</translate>
						</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import axios from "axios";

export default {
	name: "EditModule",
	components: {
		NavBar
	},
	props: ["plan"],
	data: () => ({
		error: false
	}),
	computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Subscription Plans"),
					disabled: false,
					link: true,
					to: { name: "subscription-plans" }
				},
				{
					text: this.plan.name_pt,
					disabled: true,
					link: true
				}
			];
		}
	},
	methods: {
		savePlan() {
			this.error = false;
			axios
				.post("/admin/subscription-plans/" + this.plan.id + "/edit", this.plan)
				.then(response => {
					if (response.data.result === "ok") {
						this.$router.push({
							name: "subscription-plans"
						});
					} else {
						this.error = true;
					}
				})
				.catch(error => {
					console.log(error);
					this.error = true;
				});
		}
	}
};
</script>